import axios from '@/services/api';


export const getTrailTypes= async ({ commit }, params) => {

    const response = await axios.get('/trail_types', { params: params})

    const { data } = response;

    try {
        if (data) {
            commit('setTrailTypes', data);
        }

    } catch (e) {
        console.log(e);
    }

};

export const getTrailTypeById = async ({ commit }, id) => {
    commit('setCurrentTrailType', null);
    const response = await axios.get(`/trail_types/${id}`)

    const { data } = response;

    try {
        if (data) {
            commit('setCurrentTrailType', data);
        }

    } catch (e) {
        console.log(e);
    }
}

export const add = async (_, payload) => {

    return await axios.post("trail_types", payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const edit = async (_, payload) => {

    if (payload instanceof FormData) {
        return await axios.post("trail_types", payload)
            .then((response) => response)
            .catch((e) => e.response);
    } else {
        return await axios.put("trail_types/" + payload['id'], payload)
            .then((response) => response)
            .catch((e) => e.response);
    }
    
};

export const removeImage = async (_, id) => {

    return await axios.delete("trail_type_images/" + id)
        .then((response) => response)
        .catch((e) => e.response);
};

export const deleteTrailType= async ({ commit }, id) => {

    await axios.delete(`/trail_types/${id}`)

    try {
        commit('setLoading', false);
    } catch (e) {
        console.log(e);
    }
};

